import { Component, Input, ViewChild, HostListener } from '@angular/core';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { Case } from 'src/app/models/case';
import { ServiceRequest } from 'src/app/models/service.request';
import { ValidationResult } from 'src/app/models/validation-result';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { CaseDocumentService } from 'src/app/services/documents.service';
import { Settings } from 'src/app/services/settings';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { CaseDocument } from 'src/app/models/case-document';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AddeditdocumentComponent } from './dialogs/addeditdocument/addeditdocument.component';
import { DocpreviewComponent } from './dialogs/docpreview/docpreview.component';
import { Renderer2, ElementRef } from '@angular/core';
import { RequestSummary } from 'src/app/models/request-summary';
import {
	ConfirmDialogComponent,
	ConfirmDialogModel
} from "../../../components/shared/confirmation-dialog/confirmation-dialog.component";



@Component({
	selector: 'app-case-documents',
	templateUrl: './case-documents.component.html',
	styleUrls: ['./case-documents.component.css']
})
export class CaseDocumentsComponent {

	public strErr: string | null = '';
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	isEditing = false;
	requestDate: any;
	requestType: any;
	source: any;
	statusDesc: any;
	agencyName: any;
	amountRequested: any;
	status: any;
	statusColor = '';
	lastElementId: number = -1;
	public selectedRecord: any;

	public result: boolean | null = false;
	public contentClassName: string | null = 'dwtable-container-bottom-without-save-strip';

	public requestSummary: RequestSummary;

	_caseId = 0;
	_serviceRequest: ServiceRequest;
	caseRecord: Case;

	public Idx: number | null = -1;
	public records: CaseDocument[];
	public historyMemberRecords: CaseDocument[];
	public dataSource: MatTableDataSource<CaseDocument>;
	public renderedData: Array<any>;
	public displayedColumns: string[];
	public busyCursor: boolean = false;

	visibleAddEditDocumentDialog = false;
	visiblePreviewDocDialog = false;
	strAddEditHeader = '';
	showOldDocuments = false;

	public showDocuments = false;
	public addDocuments = false;
	public deleteDocuments = false;
	public editDocuments = false;
	public viewDocumentImage = false;
	public showAllApplicantDocuments = false;
	public reviewedDocuments = false;


	public primaryAgencyFlag: boolean = false;

	@ViewChild('addeditdocument', { static: true }) addeditdocument: AddeditdocumentComponent;
	@ViewChild('previewDoc', { static: true }) previewDoc: DocpreviewComponent;

	fromSource: string;
	@Input() set from(value: string) {
		this.fromSource = value;
	}


	constructor(private serviceRequestsService: ServiceRequestsService, public dialog: MatDialog,
		private caseDocumentService: CaseDocumentService, private renderer: Renderer2, private el: ElementRef) {
		this.requestSummary = new RequestSummary();
	}

	public ngOnInit() {
		this.setSecurityPrivileges();
	}
	setSecurityPrivileges() {
		if (this.fromSource === 'cases') {
			this.showDocuments = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_DOCUMENTS', "SHOW");
			this.addDocuments = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_DOCUMENTS_ADD', "EXECUTE");
			this.deleteDocuments = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_DOCUMENTS_DELETE', "EXECUTE");
			this.editDocuments = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_DOCUMENTS_EDIT', "EXECUTE");
			this.viewDocumentImage = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_DOCUMENTS_VIEW_IMAGE', "SHOW");
			this.showAllApplicantDocuments = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_DOCUMENTS_SHOW_ALL_DOCS', "SHOW");
			this.reviewedDocuments = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_DOCUMENTS_MARK_READ', "EXECUTE");
		} else {
			this.showDocuments = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_DOCUMENTS', "SHOW");
			this.addDocuments = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_DOCUMENTS_ADD', "EXECUTE");
			this.deleteDocuments = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_DOCUMENTS_DELETE', "EXECUTE");
			this.editDocuments = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_DOCUMENTS_EDIT', "EXECUTE");
			this.viewDocumentImage = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_DOCUMENTS_VIEW_IMAGE', "SHOW");
			this.showAllApplicantDocuments = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_DOCUMENTS_SHOW_ALL_DOCS', "SHOW");
			this.reviewedDocuments = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_DOCUMENTS_MARK_READ', "EXECUTE");
		}
		if(this.viewDocumentImage){
			this.displayedColumns = ['icon', 'reviewedFlag', 'documentType', 'dateAdded', 'addedBy', 'edit', 'delete'];
		} else{
			this.displayedColumns = ['reviewedFlag', 'documentType', 'dateAdded', 'addedBy', 'edit', 'delete'];
		}

	}
	public onShowHandler(caseId: number, serviceRequest: ServiceRequest) {
		this._caseId = caseId;
		this._serviceRequest = serviceRequest;
		if (this._caseId < 1) {
			return;
		}
		this.primaryAgencyFlag = Settings.getInstance().isPrimaryAgency(this._serviceRequest.agencyId);
		this.isEditing = false;
		this.busyCursor = true;
		this.serviceRequestsService.getCaseById(this._caseId).subscribe(
			(result1) => {
				this.caseRecord = new Case();
				Object.assign(this.caseRecord, result1);
				this.displayDetails();
				this.busyCursor = false;
				this.loadDocuments();
			},
			(error1) => {
				Settings.getInstance().handleError('Error: unable to retrieve case details from the server');
				this.busyCursor = false;
			}
		);

	}
	public loadDocuments() {

		this.busyCursor = true;
		this.caseDocumentService.getAllCaseDocumentsForCase(this._caseId, this.showOldDocuments)
			.subscribe(
				(result2) => {
					this.records = result2.filter(rec => rec.documentCategoryId != Settings.getInstance().AvtarDocumentCategoryId);
					this.historyMemberRecords = [];
					Object.assign(this.historyMemberRecords, result2);
					for (const rec of this.records) {
						try {
							rec['date_added'] = Settings.getInstance().formatDate(rec.dateAdded);
						} catch (Exception) { }
					}
					this.dataSource = new MatTableDataSource(this.records);
					this.dataSource.sort = this.sort;
					this.busyCursor = false;

				},
				(error1) => {
					Settings.getInstance().handleError('Error: unable to retrieve document details from the server');
					this.busyCursor = false;
				}
			);

	}
	public addNewClickHandler() {
		this.strAddEditHeader = 'Add a new document';
		this.visibleAddEditDocumentDialog = true;
		this.addeditdocument.onShowHandler(true, this._caseId, null);
	}
	public editCaseDocumentHandler(caseDoc: CaseDocument) {
		this.strAddEditHeader = 'Edit Document';
		this.visibleAddEditDocumentDialog = true;
		this.addeditdocument.onShowHandler(false, this._caseId, caseDoc);
	}
	public validateFields(record: Case): boolean {

		this.strErr = '';
		const vr: ValidationResult = record.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		return true;
	}

	public cancelSubmitRecord() {
		this.isEditing = false;
		this.records = [];
		Object.assign(this.records, this.historyMemberRecords);
		this.dataSource = new MatTableDataSource(this.records);
	}

	public displayDetails() {
		if (this._serviceRequest) {
			this.setRequestSummary();
		}
	}
	public getStatusColor(requestStatusId: number): string {
		switch (requestStatusId) {
			case 1:
				return 'black'; // Unmatched
			case 2:
				return 'blue'; // Matched
			case 3:
				return 'green'; // Approved
			case 4:
				return 'red'; // Denied
			case 5:
				return 'orange'; // Cancelled
			default:
				return ''; // Handle any other status or return a default color
		}
	}
	public deleteCaseDocument(element) {
		const message = 'Remove Document: "' + element.documentName + '" - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.caseDocumentService.removeCaseDocumentFile(element.id).subscribe(
					(data) => {
						this.loadDocuments();
					},
					(error) => {
						Settings.getInstance().handleError(error);
					});
			}
		});
	}
	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {

		if (this.dataSource === undefined) {
			return;
		}

		if (event.direction === 'asc') {
			this.records.sort((a, b) =>
				a[event.active].localeCompare(b[event.active]));
		} else {
			this.records.sort((a, b) =>
				b[event.active].localeCompare(a[event.active]));
		}

		this.dataSource.data = this.records;
	}
	public submitAddEditWindowHandler() {
		this.visibleAddEditDocumentDialog = false;
		this.loadDocuments();
	}
	public openDocument(document: CaseDocument) {
		this.caseDocumentService.getCaseDocumentFile(document.id).subscribe(
			(data) => {
				const blob = new Blob([data], { type: 'image/jpeg' });
				const link = this.renderer.createElement('a');
				this.renderer.setProperty(link, 'href', URL.createObjectURL(blob));
				/*	this.renderer.setProperty(link, 'download', document.documentName); */
				this.renderer.appendChild(this.el.nativeElement, link);
				link.click();
				this.renderer.removeChild(this.el.nativeElement, link);
				URL.revokeObjectURL(link.href);
			},
			(error) => {
				console.error('Error fetching document:', error);
			}
		);
	}
	public reviewedFlagSelectionToggle(element: CaseDocument) {
		element.readFlag = element.readFlag ? 1 : 0;
		const temp = element['date_added'];
		delete element['date_added'];

		this.caseDocumentService.updateCaseDocument(element).subscribe(
			(data) => {
				element['date_added'] = temp;
			},
			(error) => {
				this.strErr = 'Error: The server could not update this record';
				return;
			});
	}

	public showDocumentPreview(element: CaseDocument) {
		if(!this.viewDocumentImage){
			return;
		}
		if (element.id === this.lastElementId) {
			this.visiblePreviewDocDialog = false;
			this.lastElementId = -1;
			return;
		}
		else {
			this.visiblePreviewDocDialog = true;
		}

		this.lastElementId = element.id;
		this.previewDoc.onShowHandler(element.id, (element.documentName.endsWith('.pdf') ? 'pdf' : 'image'));
	}
	public hideDocumentPreview() {
		this.visiblePreviewDocDialog = false;
	}

	public showOldDocumentsSelectionToggle() {
		this.onShowHandler(this._caseId, this._serviceRequest);
	}
	public setRequestSummary(): void {
		if (!this._serviceRequest || this._serviceRequest.id === 0) {
			return;
		}
		this.requestSummary.dateCreated = Settings.getInstance().formatDate(this._serviceRequest.dateCreated);
		this.requestSummary.requestType = this._serviceRequest.serviceRequestDesc;
		this.requestSummary.statusDesc = this._serviceRequest.requestStatusDesc;
		this.requestSummary.amountRequested = this._serviceRequest.amountRequested.toString();
		this.requestSummary.unitOfMeasure = this._serviceRequest.unitOfMeasure;
		this.requestSummary.currentNeed = this._serviceRequest.currentNeed;

		if (this._serviceRequest.flatRequestId) {
			this.requestSummary.source = 'Universal Form';
		} else {
			this.requestSummary.source = 'Data Entry';
		}
		this.requestSummary.agencyName = Settings.getInstance().getAgencyName(this._serviceRequest.agencyId);
		this.requestSummary.statusColor = this.getStatusColor(this._serviceRequest.requestStatusId);
	}
	public trimDescription(description: string): string {
		try {
			const trimmedDescription = description.trim();
			const splitDescription = trimmedDescription.split('-');
			const cleanedDescription = splitDescription[0].trim();
			return cleanedDescription;
		} catch (error) {
			console.error('Error cleaning up description:', error);
			return description; // Return the original description in case of an error
		}
	}
	public onRowClicked(row: any): void {
		this.selectedRecord = row;
		this.selectRow();
		this.displayDetails()
	}
	public onRowDblClick(): void {
		if (!this.editDocuments || this.caseRecord.caseStatus != 'Open') {
			return;
		}

		if (this._serviceRequest.recordStatus === 1) {
			this.editCaseDocumentHandler(this.selectedRecord);
		}
	}
	public tableKeyDown(event: KeyboardEvent) {

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.displayDetails();
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.displayDetails();
			}
		} else if (event.key === 'Enter') {
			if ((this.Idx >= 0) && (this.selectedRecord !== undefined)) {
				this.editCaseDocumentHandler(this.selectedRecord);
			}
		}
	}
	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}
	public unSelectRow() {

		this.Idx = -1;
		this.selectedRecord = new CaseDocument();
		this.displayDetails();

	}

}
